import NextIcon from '@assets/images/common/icon/arrow/next.svg';
import { Link } from 'react-router-dom';

export type ArticleSidebarContent = {
  to: string;
  title: string;
  date?: string;
};

type Props = {
  title: string;
  contents: ArticleSidebarContent[];
  noContentMessage: string;
  navigateButtonLabel?: string;
  onNavigate: () => void;
};

export default function ArticleSidebarItem({
  title,
  contents,
  noContentMessage,
  navigateButtonLabel,
  onNavigate,
}: Props) {
  return (
    <div className=''>
      <h2 className='mb-3 text-sm font-semibold'>{title}</h2>
      {contents.length > 0 ? (
        <ul className='flex flex-col gap-1'>
          {contents.map((content, index) => (
            <li
              className='rounded-md bg-white'
              key={index}
            >
              <Link
                to={content.to}
                className='flex flex-col gap-1 px-[13px] py-3 transition-colors hover:text-primary-500'
              >
                <time
                  dateTime={content.date}
                  className='text-[10px] text-gray-400'
                >
                  {content.date}
                </time>
                <p className='line-clamp-2 text-xs font-medium leading-[1.6]'>{content.title}</p>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className='text-xs text-gray-500'>{noContentMessage}</p>
      )}
      <div className='mt-4 flex justify-end'>
        <button
          onClick={onNavigate}
          className='inline-flex h-[25px] items-center gap-[6px] rounded-[100px] border border-gray-200 bg-gray-50 px-4 text-xs transition-opacity hover:opacity-80'
        >
          {navigateButtonLabel}
          <img
            src={NextIcon}
            alt=''
            width='9'
            height='9'
            loading='lazy'
          />
        </button>
      </div>
    </div>
  );
}
